import { getObjectFields } from '~/Util'

export const getHistoryAsset = asset => {
  const historyAsset = getObjectFields(asset)
  delete historyAsset.thumbnail
  return historyAsset
}
